import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var chipClearButton = createRuntimeFn({defaultClassName:'fx_e395032e_d670rg2',variantClassNames:{size:{'default':'fx_e395032e_d670rg3',large:'fx_e395032e_d670rg4'}},defaultVariants:{size:'default'},compoundVariants:[]});

export { chipClearButton };
//# sourceMappingURL=clearButton.vanilla.mjs.map
